import { TopBarTranslation } from './topBar.translation.en';

export const topBarTranslation: TopBarTranslation = {
  feedback: 'Podziel się swoją opinią',
  instruction: 'Instrukcja obsługi',
  language: 'Język',
  lng: {
    english: 'English',
    polish: 'Polski',
  },
  logout: 'Wyloguj się',
  notifications: {
    noNotifications: 'Brak nowych powiadomień',
    seeAll: 'Zobacz wszystkie powiadomienia',
    tooltip: 'Powiadomienia',
  },
  profile: 'Mój profil',
  start: 'Start',
  theme: {
    dark: 'Ciemny motyw',
    label: 'Motyw',
    light: 'Jasny motyw',
  },
};
